import { AUTH_TOKEN_KEY, BASE_URL } from '@/config/constants';

const parseDownloadFilename = (contentDisposition: string | null, fallback: string) => {
  if (!contentDisposition) {
    return fallback;
  }

  const match = contentDisposition.match(/filename="?([^";]+)"?/i);
  return match?.[1] || fallback;
};

const triggerDownload = (blob: Blob, filename: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const downloadExport = async (endpoint: string, fallbackFilename: string) => {
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  const response = await fetch(`${BASE_URL}${endpoint}`, {
    method: 'GET',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  if (!response.ok) {
    const data = (await response.json().catch(() => ({}))) as { error?: string };
    throw new Error(data.error || `HTTP ${response.status}`);
  }

  const blob = await response.blob();
  const filename = parseDownloadFilename(
    response.headers.get('content-disposition'),
    fallbackFilename
  );
  triggerDownload(blob, filename);
};

export const exportsApi = {
  downloadMainDatabase: () => downloadExport('/exports/database/main', 'main.sqlite'),
  downloadTenantDatabase: (tenantSlug: string) =>
    downloadExport(`/exports/database/tenant/${tenantSlug}`, `tenant_${tenantSlug}.sqlite`),
  downloadTenantAssetsArchive: (tenantSlug: string) =>
    downloadExport(`/exports/assets/${tenantSlug}`, `tenant_${tenantSlug}_assets.tar.gz`),
};
